/**
 * Shimmer skeleton placeholders used while data loads. Pure presentational;
 * styled by .skel* classes in styles.css.
 */

export function SkeletonLine({ width }: { width?: string }) {
  return <div className="skel skel-line" style={width ? { width } : undefined} />;
}

/** A skeleton shaped like a Discover result card (graphic + body). */
export function SkeletonDiscCard() {
  return (
    <div className="card skel-card" aria-hidden="true">
      <div className="skel skel-block" />
      <div className="skel-body">
        <div className="skel skel-title" />
        <SkeletonLine width="80%" />
        <SkeletonLine width="60%" />
        <SkeletonLine width="40%" />
      </div>
    </div>
  );
}

/** A generic card-shaped skeleton. */
export function SkeletonCard() {
  return (
    <div className="card" aria-hidden="true">
      <div className="skel skel-title" />
      <SkeletonLine width="90%" />
      <SkeletonLine width="70%" />
    </div>
  );
}

/** Render N skeletons of a given kind. */
export function SkeletonList({
  count = 5,
  variant = "disc",
}: {
  count?: number;
  variant?: "disc" | "card";
}) {
  const Item = variant === "disc" ? SkeletonDiscCard : SkeletonCard;
  return (
    <div aria-busy="true" aria-live="polite">
      {Array.from({ length: count }).map((_, i) => (
        <Item key={i} />
      ))}
    </div>
  );
}
